<template>
  <v-btn
    :id="id"
    class="text-none"
    :class="[{ fullWidth: fullWidth }, { 'v-btn--active': active }, typeClass]"
    :disabled="disabled"
    :loading="loading"
    :to="to"
    :type="submit ? 'submit' : 'button'"
    @click="onClick"
  >
    <template v-if="leftIcon" #prepend>
      <AGIcon :icon="leftIcon" :size="iconSize" />
    </template>

    <slot />

    <template v-if="rightIcon" #append>
      <AGIcon :icon="rightIcon" :size="iconSize" />
    </template>
  </v-btn>
</template>

<script>
import AGIcon from '@/components/common/AGIcon.vue';
import { uniqueId } from 'lodash';

export default {
  emits: ['click'],
  components: {
    AGIcon,
  },

  props: {
    id: {
      type: String,
      default: uniqueId('ag_btn_'),
    },

    leftIcon: {
      type: String,
      default: '',
    },

    rightIcon: {
      type: String,
      default: '',
    },

    iconSize: {
      type: String,
      default: '16px',
    },

    type: {
      type: String,
      default: 'primary',
      validator(value) {
        return ['primary', 'secondary', 'tertiary', 'link'].includes(value);
      },
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    to: {
      type: [String, Object],
      default: undefined,
    },

    submit: {
      type: Boolean,
      default: false,
    },

    fullWidth: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    active: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    typeClass() {
      switch (this.type) {
        case 'primary':
          return 'ag-btn-primary';
        case 'secondary':
          return 'ag-btn-secondary';
        case 'link':
          return 'ag-btn-link';
        case 'tertiary':
        default:
          return 'ag-btn-tertiary';
      }
    },
  },

  methods: {
    onClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style scoped lang="scss">
.fullWidth {
  width: 100% !important;
}
</style>
